import React, { FunctionComponent, useState } from 'react'
import { Form, Modal, Text, Button, TextArea } from '@wework/dieter-ui'
import IMTheme from '../../style/IMTheme'
import { Radio } from 'semantic-ui-react'
import { useSidebar } from '../../hoc/withSidebar'

// eslint-disable-next-line @typescript-eslint/no-var-requires

const styles = () => {
  return {
    paper: { width: 755 },
  }
}

interface ArchiveProductProps {
  space: any
  open: boolean
  onClose: any
}

const ArchiveProduct: FunctionComponent<ArchiveProductProps> = ({
  space,
  open,
  onClose,
}) => {
  return (
    <Modal
      data-testid="archive-modal"
      style={{ height: '488px', width: '558px' }}
      open={open}
      onClose={onClose}
    >
      <Modal.Header>
        <Text
          style={{
            fontSize: IMTheme.fontSizes[7],
            fontWeight: IMTheme.fontWeights.bold,
          }}
        >
          Archive inventory
        </Text>
      </Modal.Header>
      <Modal.Content
        style={{
          fontSize: IMTheme.fontSizes[2],
          fontWeight: IMTheme.fontWeights.normal,
          marginBottom: IMTheme.spacing[4],
        }}
      >
        <Text
          style={{
            fontSize: IMTheme.fontSizes[2],
            marginBottom: IMTheme.spacing[4],
          }}
        >
          You are about to archive the inventory for 2A. Once archived, the
          inventory will no longer be available. You can unarchive it later to
          make it available again. You will have to relink the inventory again.{' '}
        </Text>
        <Text
          style={{
            lineHeight: '32px',
          }}
        >
          <b>Tell us why you are archiving this space</b>
        </Text>
        <Form
          style={{
            lineHeight: '32px',
          }}
        >
          <Form.Field>
            <Radio label="Temporary archive due to technical or physical issue in space" />
          </Form.Field>
          <Form.Field>
            <Radio label="Inventory is changing" />
          </Form.Field>
          <Form.Field>
            <Radio label="Other" />
          </Form.Field>
          <TextArea
            placeholder="Reason for archive"
            style={{
              maxHeight: '80px',
              rows: '1',
              marginTop: IMTheme.spacing[2],
            }}
          />
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <div style={{ alignSelf: 'flex-end', justifyContent: 'space-between' }}>
          <Button
            default
            variant="contained"
            size="small"
            style={{ marginRight: IMTheme.spacing[3] }}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button color="red" size="small">
            Archive
          </Button>
        </div>
      </Modal.Actions>
    </Modal>
  )
}
export default ArchiveProduct
